// მომწოდებლები — suppliers, purchases, incoming RS.GE waybills and the invoice photo.
// The waybill FORM (waybill-document) and what is stored (supplier names, purchase
// notes) stay Georgian.
export const suppliers = {
  'sup.page.1': 'მომწოდებელი წაიშალა',
  'sup.page.2': 'მომწოდებლის წაშლა',
  'sup.page.3': 'ნამდვილად გსურთ წაშლა? შესყიდვების ისტორია შენარჩუნდება, მაგრამ მომწოდებელთან კავშირი მოიხსნება.',
  'sup.page.4': 'ჩვენი ვალი',
  'sup.page.5': 'მომწოდებელი',
  'sup.page.6': ' ფოტო',
  'sup.page.7': ' ახალი',
  'sup.page.8': 'სახელი ან ტელეფონი',
  'sup.page.9': 'მომწოდებელი არ არის',
  'sup.page.10': 'გასწორებული',
  'sup.page.11': ' შესყიდვა',
  'sup.page.12': 'წინასწარ',
  'sup.page.13': ' გადახდა',
  'sup.page.14': 'შესყიდვები · {p1}',
  'sup.page.15': 'გადახდები · {p1}',
  'sup.page.16': 'შესყიდვა არ არის',
  'sup.page.17': ' ც.',
  'sup.page.18': 'ვალი ₾',
  'sup.page.19': 'გადახდა არ არის',
  'sup.page.20': 'მომწოდებლები',
  'sup.page.21': 'ჯამური ვალი: ₾',
  'sup.page.22': ' ინვოისი ფოტოდან',
  'sup.page.23': ' ახალი შესყიდვა',
  'sup.page.24': ' მომწოდებელი',
  'sup.page.25': 'მომწოდებლის ძებნა...',
  'sup.page.26': 'აირჩიეთ მომწოდებელი დეტალების სანახავად',
  'sup.page.27': '← სია',
  'sup.page.28': '(წინასწარ)',
  'sup.page.29': 'შესყიდვები',
  'sup.page.30': 'გადახდები',
  'sup.dlg.1': 'სახელი სავალდებულოა',
  'sup.dlg.2': 'მომწოდებელი განახლდა',
  'sup.dlg.3': 'მომწოდებელი დაემატა',
  'sup.dlg.4': 'მომწოდებლის რედაქტირება',
  'sup.dlg.5': 'ახალი მომწოდებელი',
  'sup.dlg.6': 'სახელი',
  'sup.dlg.7': 'მაგ. Techno Import',
  'sup.dlg.8': 'ს/კ (საიდენტ. კოდი)',
  'sup.dlg.9': 'მაგ. 405123456',
  'sup.dlg.10': 'ტელეფონი',
  'sup.dlg.11': 'საკონტაქტო პირი',
  'sup.dlg.12': 'მისამართი',
  'sup.dlg.13': 'ქ. თბილისი...',
  'sup.dlg.14': 'დამატებითი ინფო',
  'sup.pay.1': 'შეიყვანეთ თანხა',
  'sup.pay.2': 'აირჩიე ბანკი',
  'sup.pay.3': 'გადახდა შენახულია: ₾{value}',
  'sup.pay.4': ' გადახდა',
  'sup.pay.5': ' — მიმდინარე ვალი:',
  'sup.pay.6': 'თანხა ₾ ',
  'sup.pay.7': 'თანხა ვალზე მეტია — სხვაობა (',
  'sup.pay.8': '₾) წინასწარ გადახდად ჩაიწერება.',
  'sup.pay.9': 'გადახდა — ₾',
  'sup.buy.1': 'შტრიხკოდი ვერ მოიძებნა: {code}',
  'sup.buy.2': 'დაამატეთ პროდუქცია',
  'sup.buy.3': 'შესყიდვა დასრულდა — {itemsCount} ცალი, ₾{total}',
  'sup.buy.3w': 'შესყიდვა დასრულდა — {n} პოზიცია, ₾{total}',
  'sup.buy.noQty': 'ჩაწერე რაოდენობა: {name}',
  'sup.buy.4': ' ახალი შესყიდვა',
  'sup.buy.5': 'მომწოდებელი',
  'sup.buy.6': '— აირჩიეთ მომწოდებელი —',
  'sup.buy.7': '— მომწოდებლის გარეშე —',
  'sup.buy.8': 'პროდუქციის დამატება',
  'sup.buy.9': ' კამერით სკანირება',
  'sup.buy.10': 'სახელი ან შტრიხკოდი (დაასკანერე ან აკრიფე)...',
  'sup.buy.11': 'მარაგი: ',
  'sup.buy.12': ' · ფასი: ₾',
  'sup.buy.13': 'მოძებნე და დაამატე პროდუქცია',
  'sup.buy.14': 'რაოდ.',
  'sup.buy.15': 'ფასი',
  'sup.buy.16': 'ჯამი',
  'sup.buy.17': '⚠️ თვითღ. ₾',
  'sup.buy.18': ' · გასაყიდი ₾{sale_price}-ზე მარჟა დაეცემა {newMargin}%-მდე — გადახედე ფასს',
  'sup.buy.19': 'გადახდილი ₾',
  'sup.buy.20': 'სულ: ',
  'sup.buy.21': 'ვალი: ₾',
  'sup.buy.22': 'შესყიდვა',
  'sup.buy.23': 'შტრიხკოდის სკანირება',
  'sup.detail.1': 'შესყიდვა',
  'sup.detail.2': 'მომწოდებლის გარეშე',
  'sup.detail.3': 'ჯამი',
  'sup.detail.4': 'გადახდილი',
  'sup.detail.5': 'ვალი',
  'sup.detail.6': 'RS.GE-ს ზედნადებიდან · ',
  'sup.detail.7': ' იტვირთება…',
  'sup.detail.8': 'ამ შესყიდვაზე პროდუქციის სია არ შენახულა — მხოლოდ ჯამი.',
  'sup.detail.9': 'დასახელება',
  'sup.detail.10': 'რაოდ',
  'sup.detail.11': 'ერთეული',
  'sup.detail.12': 'თანხა',
  'sup.photo.1': 'AI გამორთულია — ჩართე პარამეტრებში (საკუთარი key) ან მოითხოვე ადმინისგან',
  'sup.photo.2': 'AI-მ ვერ წაიკითხა დოკუმენტი',
  'sup.photo.3': 'ფოტოს დამუშავება ვერ მოხერხდა',
  'sup.photo.4': 'ინვოისი ფოტოდან',
  'sup.photo.5': 'გადაუღე ფოტო მომწოდებლის ინვოისს ან ზედნადებს — AI წაიკითხავს, შენ გადაამოწმებ',
  'sup.photo.6': 'AI კითხულობს დოკუმენტს — ჩვეულებრივ 10–30 წამი',
  'sup.photo.7': 'გადაამოწმე რიცხვები ფურცელთან. რაც ყვითლადაა — არ ემთხვევა ან არ იკითხება.',
  'sup.photo.8': 'ფოტოს გადაღება ან არჩევა',
  'sup.photo.9': 'მთელი ფურცელი ჩარჩოში, სწორი კუთხით, კარგ სინათლეზე — ციფრები უნდა იკითხებოდეს',
  'sup.photo.10': 'AI მხოლოდ კითხულობს. საწყობში არაფერი იწერება, სანამ შენ არ დაადასტურებ.',
  'sup.photo.11': ' AI კითხულობს…',
  'sup.photo.12': 'მომწოდებელი',
  'sup.photo.13': 'დასახელება',
  'sup.photo.14': 'ს/კ',
  'sup.photo.15': 'დოკუმენტის №',
  'sup.photo.16': 'თარიღი',
  'sup.photo.17': ' ფოტოს გახსნა',
  'sup.photo.18': 'კოდი',
  'sup.photo.19': 'ერთ.',
  'sup.photo.20': 'რაოდ.',
  'sup.photo.21': 'ერთ. ფასი',
  'sup.photo.22': 'თანხა',
  'sup.photo.23': 'გამოთვალე',
  'sup.photo.24': 'ც',
  'sup.photo.25': 'ხაზის წაშლა',
  'sup.photo.26': ' ხაზის დამატება',
  'sup.photo.27': 'ხაზების ჯამი ',
  'sup.photo.28': 'დოკუმენტში',
  'sup.photo.29': 'ხაზების ჯამი ₾',
  'sup.photo.30': ' ≠ დოკუმენტის ჯამი ₾',
  'sup.photo.31': ' — ან ხაზი აკლია, ან რიცხვია არასწორად წაკითხული.',
  'sup.photo.32': 'AI-ს შენიშვნა: ',
  'sup.photo.33': ' სხვა ფოტო',
  'sup.photo.35': ' · წაკითხვა ≈ ₾{p1}',
  'sup.photo.36': 'მიღებაზე გადასვლა ',
  'sup.photo.37': 'მომწოდებლის სახელი აუცილებელია — შესყიდვა ვიღაცისგანაა. ',
  'sup.photo.38': 'ყველა ხაზს სახელი და სამივე რიცხვი სჭირდება — ყვითელი ველები შეავსე.',
  'sup.rsge.1': '„{name}" შეიქმნა და შეირჩა',
  'sup.rsge.2': 'ეს ზედნადები RS.GE-ზე გაუქმებულია — მიღება ნაშთს და ვალს ტყუილად დაამატებდა',
  'sup.rsge.3': 'აირჩიე კატეგორია {p1} პროდუქტისთვის',
  'sup.rsge.4': 'მიუთითე გასაყიდი ფასი {p1} ახალ პროდუქტზე — ან „ფასების შევსება"',
  'sup.rsge.5': ' · {createdCount} ახალი პროდუქტი შეიქმნა',
  'sup.rsge.6': 'ზედნადები მონიშნულია — საქონელი ხელით იყო შეტანილი, ნაშთი და ხარჯი არ შეცვლილა',
  'sup.rsge.7': 'მიღებულია! {matchedCount} პროდუქტს ნაშთი მოემატა · {unmatched} უცნობი ჩაიწერა მხოლოდ ხარჯში',
  'sup.rsge.8': 'მიღებულია! {matchedCount} პროდუქტს ნაშთი მოემატა',
  'sup.rsge.9': '{baseMsg} · {p1} ფასი განახლდა',
  'sup.rsge.10': '🏷️ ეტიკეტები',
  'sup.rsge.11': 'RS.GE ზედნადებები',
  'sup.rsge.12': 'ინვოისი ფოტოდან{p1}',
  'sup.rsge.13': 'ზედნადები №{p1}',
  'sup.rsge.14': 'ბოლო {days} დღის შემოსული ზედნადებები — ერთი კლიკით მიიღე საწყობში',
  'sup.rsge.15': 'RS.GE არ არის დაკავშირებული',
  'sup.rsge.16': 'პარამეტრებში შეიყვანე rs.ge-ს სერვის მომხმარებელი და ზედნადებები აქ გამოჩნდება.',
  'sup.rsge.17': 'პარამეტრებში გადასვლა',
  'sup.rsge.18': ' თავიდან ცდა',
  'sup.rsge.19': 'ზედნადებები იტვირთება...',
  'sup.rsge.20': 'ზედნადების დეტალები იტვირთება...',
  'sup.rsge.21': ' დღე',
  'sup.rsge.22': 'თარიღი = ზედნადების გამოწერის დღე',
  'sup.rsge.23': 'ბოლო ',
  'sup.rsge.24': ' დღეში შემოსული ზედნადები არ არის',
  'sup.rsge.25': 'RS.GE-სთან კავშირი წესრიგშია — სერვისის მომხმარებელი დადასტურდა. ე.ი. ამ პერიოდში მართლა არ შემოსულა ზედნადები.',
  'sup.rsge.26': 'RS.GE-მ სერვისის მომხმარებელი ვერ დაადასტურა. ცარიელი სია სწორედ ამიტომ შეიძლება იყოს — და არა იმიტომ, რომ ზედნადები არ არის.',
  'sup.rsge.27': ' RS.GE-ს პარამეტრები',
  'sup.rsge.28': ' განახლება',
  'sup.rsge.29': 'ტექნიკური დეტალები (RS.GE-ს პასუხი)',
  'sup.rsge.30': 'უცნობი მომწოდებელი',
  'sup.rsge.31': ' · ს/კ {sellerTin}',
  'sup.rsge.32': 'კორექტირებული',
  'sup.rsge.33': '✓ მიღებულია',
  'sup.rsge.34': 'მიღება შეუძლებელია',
  'sup.rsge.35': 'მიღება →',
  'sup.rsge.36': 'ზედნადები',
  'sup.rsge.37': 'მიღება საწყობში',
  'sup.rsge.38': 'ეს ზედნადები RS.GE-ზე გაუქმებულია',
  'sup.rsge.39': 'მისი მიღება საწყობს ნაშთს და მომწოდებლის ვალს ტყუილად დაამატებდა. თუ მომწოდებელმა ახალი ზედნადები გამოწერა, მიიღე ის.',
  'sup.rsge.40': 'ამ ზედნადებში ხაზები ვერ წავიკითხეთ',
  'sup.rsge.41': 'ეს არ ნიშნავს, რომ ზედნადები ცარიელია — მიღება არ დაიწყო.',
  'sup.rsge.42': 'მიმწოდებელი',
  'sup.rsge.43': 'ს/კ ',
  'sup.rsge.44': 'გამოწერილია',
  'sup.rsge.45': 'ხაზები',
  'sup.rsge.47': 'ყველა ერთ კატეგორიაში',
  'sup.rsge.48': 'თითოეულს თავისი',
  'sup.rsge.49': 'შემოთავაზებული',
  'sup.rsge.50': 'ახალი კატეგორია',
  'sup.rsge.51': 'კატეგორიის შექმნა და არჩევა',
  'sup.rsge.52': 'მარჟა',
  'sup.rsge.53': 'ფასების შევსება',
  'sup.rsge.54': 'დააბრუნე მიღებაში',
  'sup.rsge.55': 'ეს ხაზი უკვე შეტანილია ხელით — არ ჩაიწეროს მეორედ',
  'sup.rsge.56': 'დააბრუნე',
  'sup.rsge.57': 'უკვე შევიტანე',
  'sup.rsge.58': 'არ მიიღება — ნაშთი და ხარჯი არ იცვლება',
  'sup.rsge.59': 'ერთეული: ',
  'sup.rsge.60': 'ყუთში',
  'sup.rsge.61': 'რამდენი ცალია მიმწოდებლის ერთ ერთეულში (ყუთი, ბლოკი)',
  'sup.rsge.62': 'ც',
  'sup.rsge.63': 'ფასი ზუსტად ამდენჯერ მეტია, ვიდრე თქვენი თვითღირებულება',
  'sup.rsge.64': 'სახელში ეს რიცხვი წერია',
  'sup.rsge.65': 'სახელში: {namePack}',
  'sup.rsge.66': 'ფასი ზუსტად ამდენჯერ მეტია, ვიდრე თქვენი თვითღირებულება — დააჭირე, თუ ყუთია',
  'sup.rsge.67': 'სახელში ეს რიცხვი წერია — დააჭირე, თუ ეს ყუთის ზომაა',
  'sup.rsge.68': 'ყუთია? = {costPack} × ₾{purchase_price}',
  'sup.rsge.69': 'ყუთია? სახელში: {namePack}',
  'sup.rsge.70': 'ყუთი?',
  'sup.rsge.71': 'ნაშთს +',
  'sup.rsge.72': 'სხვა პროდუქტი…',
  'sup.rsge.73': 'სხვა?',
  'sup.rsge.74': 'ახალი პროდუქტი',
  'sup.rsge.75': 'გასაყიდი',
  'sup.rsge.76': 'აუცილებელია',
  'sup.rsge.77': 'კატეგორია',
  'sup.rsge.78': '— აირჩიე —',
  'sup.rsge.79': 'მხოლოდ ხარჯში — პროდუქტი არ შეიქმნება',
  'sup.rsge.80': 'სახელით ჰგავს — დააჭირე, თუ ეს ის პროდუქტია',
  'sup.rsge.81': 'უკვე მაქვს? ალბათ:',
  'sup.rsge.82': 'სხვა…',
  'sup.rsge.83': 'არსებული პროდუქტი…',
  'sup.rsge.84': 'უკვე მაქვს?',
  'sup.rsge.85': 'მხოლოდ ხარჯში — ნაშთი არ იცვლება',
  'sup.rsge.86': 'დასახელება',
  'sup.rsge.87': 'რაოდ.',
  'sup.rsge.88': 'ერთ. ფასი',
  'sup.rsge.89': 'თანხა',
  'sup.rsge.90': ' ც',
  'sup.rsge.91': ' / ც',
  'sup.rsge.92': 'მიიღება {p1} / {p2} ხაზი',
  'sup.rsge.93': 'სულ',
  'sup.rsge.94': ' ც × ',
  'sup.rsge.95': 'მიიღება {p1} / {p2}',
  'sup.rsge.96': 'მომწოდებელმა ფასი გაზარდა ',
  'sup.rsge.97': ' პროდუქტზე — მარჟა რომ არ დაგეცეს, განაახლე გასაყიდი ფასები:',
  'sup.rsge.98': 'თვითღ.: ₾',
  'sup.rsge.99': 'მიმდ. ფასი: ₾',
  'sup.rsge.100': ' (მარჟა ',
  'sup.rsge.101': 'ალბათ ყუთია: ₾',
  'sup.rsge.102': 'ყუთში ',
  'sup.rsge.103': ' — დიახ',
  'sup.rsge.104': 'ფასის განახლება',
  'sup.rsge.105': 'ახალი გასაყიდი ₾',
  'sup.rsge.106': 'ახალი საბითუმო ₾',
  'sup.rsge.107': 'შემოთავაზება ინარჩუნებს მიმდინარე მარჟას',
  'sup.rsge.108': ' მიღების შემდეგ შეძლებ განახლებული ფასების ეტიკეტების დაბეჭდვას ერთი ღილაკით',
  'sup.rsge.109': 'ეს ზედნადები ხელით შეტანილად არის მონიშნული — {p1}',
  'sup.rsge.110': 'ეს ზედნადები უკვე მიღებულია — {p1}',
  'sup.rsge.111': 'საქონელი პროგრამაში ხელით შევიდა; ეს დოკუმენტი მხოლოდ მიმწოდებელს დაუკავშირდა.',
  'sup.rsge.112': 'თავიდან მიღება ნაშთს მეორედ დაამატებდა — ამიტომ დაბლოკილია.',
  'sup.rsge.113': 'მიღებული',
  'sup.rsge.114': 'გადახდილი ₾',
  'sup.rsge.115': 'ცარიელი = სრულად გადახდილი; ნაკლები = სხვაობა ვალში',
  'sup.rsge.116': '{p1} პროდუქტს ფასი აკლია',
  'sup.rsge.117': '{p1}-ს კატეგორია',
  'sup.rsge.118': 'მიიღება {p1} ხაზი',
  'sup.rsge.119': ' გამოტოვებული',
  'sup.rsge.120': ' ხელით შეტანილად მონიშვნა',
  'sup.rsge.121': ' მიღება საწყობში',
  'sup.doc.1': ' ბეჭდვა / PDF',
  'sup.why.waybill': 'შემოთავაზება: ამავე ზედნადების ნაცნობი პროდუქტების მიხედვით',
  'sup.why.catalog': 'შემოთავაზება: სხვა მაღაზიების მიხედვით (საერთო კატალოგი)',
  'sup.why.own': 'შემოთავაზება: შენივე მსგავსი პროდუქტის მიხედვით',
  'sup.why.shelf': 'შემოთავაზება: კატეგორიის სახელში იგივე სიტყვაა',
  'sup.x.error': 'შეცდომა',
  'sup.x.noLink': 'კავშირი ვერ შედგა',
  'sup.x.popup': 'ბრაუზერმა ახალი ფანჯარა დაბლოკა — დაუშვით pop-up ამ საიტისთვის',
  'sup.photo.lines': '{n} ხაზი',
  'sup.rsge.newCount': '{n} ახალი პროდუქტი',
  'sup.dlg.contactPh': 'სახელი',
  // 170 — return to supplier
  'sup.ret.errQty': 'რაოდენობა 0-ზე მეტი უნდა იყოს',
  'sup.ret.errWhole': 'ცალობით — მხოლოდ მთელი რიცხვი',
  'sup.ret.errCredit': 'ფასი უარყოფითი ვერ იქნება',
  'sup.ret.errStock': 'ამ ფილიალში იმდენი არ არის',
  'sup.ret.errRoom': 'ამ შესყიდვიდან იმდენი აღარ დარჩა',
  'sup.ret.errDecimals': 'მაქსიმუმ 3 ციფრი მძიმის შემდეგ (გრამამდე)',
  'sup.ret.lowCredit': 'ფასი თვითღირებულებაზე (₾{wac}) ბევრად დაბალია — სხვაობა დარჩენილი {left}-ის თვითღირებულებაში ჩაჯდება: ₾{wac} → ₾{next}',
  // 171 — where the money paid at receiving came from
  'sup.src.title': 'საიდან გადაიხადე?',
  'sup.src.drawer': 'სალაროდან',
  'sup.src.bank': 'ბანკით',
  'sup.src.other': 'სხვა',
  'sup.src.drawerHint': 'Z-ში სალაროს გასავლად ჩაჯდება',
  'sup.src.err': 'მიუთითე, საიდან გადაიხადე',
  'sup.src.errShift': 'ჯერ გახსენი ცვლა — სალაროდან გადახდა ცვლაში იწერება',
  'sup.src.owner': 'პირადი თანხით',
  'sup.src.ownerHint': 'მფლობელის ჯიბიდან — სალარო და ბანკი არ იცვლება',
  'sup.src.none': 'არ არის მითითებული',
  'sup.src.label': 'გადახდის წყარო: ',
  'sup.ret.offline': 'მომწოდებელთან დაბრუნება ინტერნეტის გარეშე არ იწერება',
  'sup.ret.failed': 'დაბრუნება ვერ ჩაიწერა',
  'sup.ret.movementLinked': 'ეს თანხა დოკუმენტს ეკუთვნის (დაბრუნება ან მიღება) — ცალკე ვერ წაიშლება',
  'sup.ret.title': 'მომწოდებელთან დაბრუნება',
  'sup.ret.open': 'დაბრუნება',
  'sup.ret.fromPurchase': 'შესყიდვიდან ₾{total}',
  'sup.ret.search': 'მოძებნე ან დაასკანერე, რაც ბრუნდება',
  'sup.ret.have': 'აქ არის {n}',
  'sup.ret.room': 'ამ შესყიდვიდან დარჩა {n}',
  'sup.ret.loading': 'შესყიდვის ხაზები იტვირთება…',
  'sup.ret.empty': 'დაამატე, რაც ბრუნდება',
  'sup.ret.fix': 'ჯერ გაასწორე წითლად მონიშნული ხაზები',
  'sup.ret.qty': 'რაოდენობა',
  'sup.ret.credit': 'ერთეულის ფასი',
  'sup.ret.settleTitle': 'როგორ გვიბრუნებს?',
  'sup.ret.debt': 'ვალიდან დაკლება',
  'sup.ret.debtHint': 'მომწოდებლის ვალი შემცირდება',
  'sup.ret.cash': 'ფული სალაროში',
  'sup.ret.cashHint': 'Z-ში სალაროში შემოტანად ჩაჯდება',
  'sup.ret.noShift': 'ჯერ გახსენი ცვლა',
  'sup.ret.swap': 'იგივე საქონელზე გაცვალა? ჩაწერა არ სჭირდება — მარაგი და ფული არ იცვლება.',
  'sup.ret.total': 'სულ ბრუნდება',
  'sup.ret.submit': 'დაბრუნება ₾{total}',
  'sup.ret.doneDebt': 'დაბრუნდა ₾{total} — ვალი შემცირდა',
  'sup.ret.doneCash': 'დაბრუნდა ₾{total} — ფული სალაროშია',
  'sup.ret.row': 'დაბრუნება',
  'sup.ret.rowDebt': 'ვალიდან',
  'sup.ret.rowCash': 'სალაროში',
  'sup.ret.returned': 'დაბრუნებულია {n}',
  'sup.ret.loss': 'სხვაობა ხარჯად ₾{x}',
  'sup.ret.gain': 'მოგება დაბრუნებაზე ₾{x}',
} as const
